import type { ColumnChartValue } from "@wayflyer/flyui-dataviz";

import type { LtvCacChartProps } from "./ltv-cac";

export const getLtvCacColumnValues = (
  data: LtvCacChartProps["data"],
  field: "currentValue" | "referenceValue" | "referenceContinuationValue"
): ColumnChartValue[] =>
  (data ?? []).map((row, index) => {
    const rawValue = row[field];
    const value = rawValue == null ? null : Number(rawValue);
    return {
      category: String(index),
      y: value != null && Number.isFinite(value) ? value : null,
      datum: row,
    };
  });
